import gql from "graphql-tag";

export const deleteManagerMutation = gql`
  mutation deleteManager($id: ID!) {
    deleteManager(id: $id) {
      id
    }
  }
`;
